module.exports = __webpack_public_path__ + "static/media/noun_Check.089dcdf7.svg";